(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

function setCookie(cname, cvalue, seconds) {
  var d = new Date();
  d.setTime(d.getTime() + seconds * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
} // Read a page's GET URL variables and return them as an associative array.


function getUrlVars() {
  var vars = [],
      hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }

  return vars;
}

jQuery(document).ready(function () {
  jQuery(document).on("click", ".terms-and-conditions-info a", function (event) {
    event.preventDefault();

    if (jQuery(".terms-popup iframe").attr("src") == '') {
      jQuery(".terms-popup iframe").attr("src", jQuery(this).attr('href'));
    }

    jQuery(".terms-popup").fadeIn();
  });
  jQuery('.terms-popup i').on('click', function () {
    jQuery('.terms-popup').fadeOut();
  });

  if (getUrlVars()["submit"] == "true") {
    setTimeout(function () {
      if (getCookie('username') != 'NULL' && getCookie('username') != '') jQuery('#username').val(getCookie('username'));
      if (getCookie('password') != 'NULL' && getCookie('password') != '') jQuery('#password').val(getCookie('password'));
      if (getCookie('billing_first_name') != 'NULL' && getCookie('billing_first_name') != '') jQuery('#billing_first_name').val(getCookie('billing_first_name'));
      if (getCookie('billing_last_name') != 'NULL' && getCookie('billing_last_name') != '') jQuery('#billing_last_name').val(getCookie('billing_last_name'));
      if (getCookie('billing_address_1') != 'NULL' && getCookie('billing_address_1') != '') jQuery('#billing_address_1').val(getCookie('billing_address_1'));
      if (getCookie('billing_bloc') != 'NULL' && getCookie('billing_bloc') != '') jQuery('#billing_bloc').val(getCookie('billing_bloc'));
      if (getCookie('billing_apartament') != 'NULL' && getCookie('billing_apartament') != '') jQuery('#billing_apartament').val(getCookie('billing_apartament'));
      if (getCookie('billing_scara') != 'NULL' && getCookie('billing_scara') != '') jQuery('#billing_scara').val(getCookie('billing_scara'));
      if (getCookie('billing_etaj') != 'NULL' && getCookie('billing_etaj') != '') jQuery('#billing_etaj').val(getCookie('billing_etaj'));
      if (getCookie('billing_city') != 'NULL' && getCookie('billing_city') != '') jQuery('#billing_city').val(getCookie('billing_city'));
      if (getCookie('billing_phone') != 'NULL' && getCookie('billing_phone') != '') jQuery('#billing_phone').val(getCookie('billing_phone'));
      if (getCookie('billing_email') != 'NULL' && getCookie('billing_email') != '') jQuery('#billing_email').val(getCookie('billing_email'));

      if (getCookie('delivery_hour_on') != 'NULL') {
        jQuery('input[value="' + getCookie('delivery_hour_on') + '"]').trigger('click');
      }

      if (getCookie('delivery_hour_on_now') != 'NULL' && getCookie('delivery_hour_on_now') == '1') {
        jQuery("#delivery_hour_on_now").prop("checked", true);
      } else {
        jQuery("#delivery_hour_on_now").prop("checked", false);
      }

      if (getCookie('delivery_hour_on_choose_date') != 'NULL' && getCookie('delivery_hour_on_choose_date') == '1') {
        jQuery("#delivery_hour_on_choose_date").prop("checked", true);
        jQuery('#delivery_time_field, #delivery_hour_field').css('display', 'block');
      }

      if (getCookie('delivery_time') != 'NULL' && getCookie('delivery_time') != '') jQuery('#delivery_time').val(getCookie('delivery_time'));
      if (getCookie('delivery_hour') != 'NULL' && getCookie('delivery_hour') != '') jQuery('#delivery_hour').val(getCookie('delivery_hour'));
      if (getCookie('my_checkbox') != 'NULL' && getCookie('my_checkbox') == '1') setTimeout(function () {
        jQuery('#my_checkbox').prop("checked", true);
      }, 250);

      if (getCookie('terms_and_conditions') != 'NULL' && getCookie('terms_and_conditions') == '1') {
        jQuery('#terms_and_conditions').prop("checked", true);
      }

      if (getCookie('gdpr') != 'NULL' && getCookie('gdpr') == '1') jQuery('#gdpr').prop("checked", true);

      if (getCookie('createaccount') != 'NULL' && getCookie('createaccount') == '1') {
        jQuery('#createaccount').prop("checked", true);
        jQuery('.create-account').css('display', 'block');
      }

      if (getCookie('delivery_method') != 'NULL' && getCookie('delivery_method') != '') {
        jQuery('#delivery_method').val(getCookie('delivery_method'));
      }

      if (getCookie('delivery_method_v2') != 'NULL' && getCookie('delivery_method_v2') != '') {
        setTimeout(function () {
          jQuery('#delivery_method .blue-cards input[value=' + getCookie('delivery_method_v2') + ']').parent().trigger('click');
        }, 250);
      }

      if (getCookie('account_password') != 'NULL' && getCookie('account_password') != '') jQuery('#account_password').val(getCookie('account_password'));

      if (getCookie('payment_method') != 'NULL' && getCookie('payment_method') != '') {
        jQuery('select[name="payment_method"]').val(getCookie('payment_method'));
        if (getCookie('payment_method') == 'netopiapayments') jQuery('#netopia_method_pay').val('credit_card');
      }

      if (getCookie('payment_method_v2') != 'NULL' && getCookie('payment_method_v2') != '') {
        setTimeout(function () {
          jQuery('#payment_method .blue-cards input[value=' + getCookie('payment_method_v2') + ']').parent().trigger('click');
        }, 200);
        if (getCookie('payment_method_v2') == 'netopiapayments') jQuery('#netopia_method_pay').val('credit_card');
      }

      if (getCookie('order_comments') != 'NULL' && getCookie('order_comments') != '') jQuery('#order_comments').val(getCookie('order_comments'));
      setTimeout(function () {
        jQuery('#place_order').click();
      }, 350);
    }, 350);
  }
});
jQuery(document).ready(function ($) {
  jQuery("select[name='payment_method']").on('change', function () {
    if (this.value == "netopiapayments") {
      // credit_card
      localStorage.setItem('paymentMethod', 'netopiapayments');
    } else {
      localStorage.setItem('paymentMethod', '');
    }
  });
  jQuery('.blue-cards label').on('click', function () {
    if (jQuery(this).find('input').val() == "netopiapayments") {
      localStorage.setItem('paymentMethod', 'netopiapayments');
    } else {
      localStorage.setItem('paymentMethod', '');
    }
  });
  $(document).on('click', '.fake-checkout-button', function (e) {
    var delivery_method = $('#delivery_method .blue-cards input[name=delivery_method]:checked', '.woocommerce-checkout').val();
    var payment_method = $('#payment_method .blue-cards input[name=payment_method]:checked', '.woocommerce-checkout').val();
    var delivery_hour_on = $('input[name=delivery_hour_on]:checked', '.woocommerce-checkout').val(); //e.preventDefault();

    if ($('#username').val() != 'undefined' || $('#username').val() != '') setCookie('username', $('#username').val(), 60);
    if ($('#password').val() != 'undefined' || $('#password').val() != '') setCookie('password', $('#password').val(), 60);
    if ($('#billing_first_name').val() != 'undefined' || $('#billing_first_name').val() != '') setCookie('billing_first_name', $('#billing_first_name').val(), 60);
    if ($('#billing_last_name').val() != 'undefined' || $('#billing_last_name').val() != '') setCookie('billing_last_name', $('#billing_last_name').val(), 60);
    if ($('#billing_address_1').val() != 'undefined' || $('#billing_address_1').val() != '') setCookie('billing_address_1', $('#billing_address_1').val(), 60);
    if ($('#billing_city').val() != 'undefined' || $('#billing_city').val() != '') setCookie('billing_city', $('#billing_city').val(), 60);
    if ($('#billing_phone').val() != 'undefined' || $('#billing_phone').val() != '') setCookie('billing_phone', $('#billing_phone').val(), 60);
    if ($('#billing_bloc').val() != 'undefined' || $('#billing_bloc').val() != '') setCookie('billing_bloc', $('#billing_bloc').val(), 60);
    if ($('#billing_apartament').val() != 'undefined' || $('#billing_apartament').val() != '') setCookie('billing_apartament', $('#billing_apartament').val(), 60);
    if ($('#billing_scara').val() != 'undefined' || $('#billing_scara').val() != '') setCookie('billing_scara', $('#billing_scara').val(), 60);
    if ($('#billing_etaj').val() != 'undefined' || $('#billing_etaj').val() != '') setCookie('billing_etaj', $('#billing_etaj').val(), 60);
    if ($('#billing_email').val() != 'undefined' || $('#billing_email').val() != '') setCookie('billing_email', $('#billing_email').val(), 60);

    if ($('#delivery_hour_on_now').val() != 'undefined' || $('#delivery_hour_on_now').val() != '') {
      var val = $('#delivery_hour_on_now:checked').length > 0 ? '1' : '';
      setCookie('delivery_hour_on_now', val, 60);
    }

    if ($('#delivery_hour_on_choose_date').val() != 'undefined' || $('#delivery_hour_on_choose_date').val() != '') {
      var val = $('#delivery_hour_on_choose_date:checked').length > 0 ? '1' : '';
      setCookie('delivery_hour_on_choose_date', val, 60);
    }

    if ($('#delivery_time').val() != 'undefined' || $('#delivery_time').val() != '') setCookie('delivery_time', $('#delivery_time').val(), 60);
    if ($('#delivery_hour').val() != 'undefined' || $('#delivery_hour').val() != '') setCookie('delivery_hour', $('#delivery_hour').val(), 60);

    if ($('#my_checkbox').val() != 'undefined' || $('#my_checkbox').val() != '') {
      var val = $('#my_checkbox:checked').length > 0 ? '1' : '';
      setCookie('my_checkbox', val, 60);
    }

    if ($('#terms_and_conditions').val() != 'undefined' || $('#terms_and_conditions').val() != '') {
      var val = $('#terms_and_conditions:checked').length > 0 ? '1' : '';
      setCookie('terms_and_conditions', val, 60);
    }

    if ($('#gdpr').val() != 'undefined' || $('#gdpr').val() != '') {
      var val = $('#gdpr:checked').length > 0 ? '1' : '';
      setCookie('gdpr', val, 60);
    }

    if ($('#createaccount').val() != 'undefined' || $('#createaccount').val() != '') {
      var val = $('#createaccount:checked').length > 0 ? '1' : '';
      setCookie('createaccount', val, 60);
    }

    if ($('#delivery_method').val() != 'undefined' || $('#delivery_method').val() != '') setCookie('delivery_method', $('#delivery_method').val(), 60);

    if (delivery_method != 'undefined' && delivery_method != '') {
      setCookie('delivery_method_v2', delivery_method, 60);
    }

    if (delivery_hour_on != 'undefined' && delivery_hour_on != '') {
      setCookie('delivery_hour_on', delivery_hour_on, 60);
    }

    if ($('#account_password').val() != 'undefined' || $('#account_password').val() != '') setCookie('account_password', $('#account_password').val(), 60);
    if ($('select[name="payment_method"]').val() != 'undefined' || $('select[name="payment_method"]').val() != '') setCookie('payment_method', $('select[name="payment_method"]').val(), 60);

    if (payment_method != 'undefined' && payment_method != '') {
      setCookie('payment_method_v2', payment_method, 60);
    }

    if ($('#order_comments').val() != 'undefined' || $('#order_comments').val() != '') setCookie('order_comments', $('#order_comments').val(), 60);
  }); // Remove links from the products list

  jQuery('.order_details td.product-name a').removeAttr('href'); // Fix the bug for checkout error

  jQuery(document.body).on('checkout_error', function () {
    jQuery(document.body).trigger('update_checkout');
  });
  var urlParams = new URLSearchParams(window.location.search);
  var safeAreaInsetsBottom = urlParams.get('safeAreaInsetsBottom') ? parseInt(urlParams.get('safeAreaInsetsBottom')) : getCookie('safeAreaInsetsBottom') ? parseInt(getCookie('safeAreaInsetsBottom')) : 0;
  var isIos = urlParams.get('isIos') ? urlParams.get('isIos') : getCookie('isIos') ? getCookie('isIos') : 'false';
  setCookie('isIos', isIos, 30);
  setCookie('safeAreaInsetsBottom', safeAreaInsetsBottom, 30);
  isIos = getCookie('isIos');
  safeAreaInsetsBottom = parseInt(getCookie('safeAreaInsetsBottom'));

  if (isIos === 'true' && safeAreaInsetsBottom > 0) {
    jQuery('body.page-template-template-empty').css('padding-bottom', 2 * safeAreaInsetsBottom + 'px');
  }

  if (isIos === 'true' && safeAreaInsetsBottom === 0) {
    jQuery('body.page-id-585 #site-content').css('padding-bottom', '70px');
  }

  jQuery("#delivery_hour_on").on('change', function () {
    if (jQuery("#delivery_hour_on").is(':checked')) {
      jQuery('#delivery_time_field.old-checkout').css('display', 'block');
    } else {
      jQuery('#delivery_time_field.old-checkout #delivery_time').val('');
      jQuery('#delivery_time_field.old-checkout').css('display', 'none');
    }
  });
  jQuery('body').on('click', '.showlogin', function () {
    window.scrollTo(0, 0);
    jQuery("#apiLogin").toggle();
  });
  jQuery(".close-popup").click(function () {
    jQuery(".popup-wrapper").css('display', 'none');
  });
  jQuery(".lost_password a").click(function () {
    jQuery(".popup-wrapper").css('display', 'block');
  });
  venueService().getVenueDetails().done(function (responseData) {
    var data = responseData.data;
    _venueId = data.id;
  });
  $(document).on("click", ".woocommerce-form-login__submit", function (event) {
    event.preventDefault();
    var username = jQuery('#username').val();
    var password = jQuery('#password').val();

    if (username == "" || password == "") {
      if (typeof invalid_login_message !== 'undefined') {
        alert(invalid_login_message);
      } else {
        alert('Please add username and password.');
      }

      return;
    }

    new lsHelper().generateDeviceId();

    try {
      window.top.localStorage.setItem("deviceId", _deviceId);
    } catch (e) {}

    ;
    authenticateService().login(username, password).done(function (responseData) {
      authenticateProfile().setToken(responseData.access_token, responseData.refresh_token).done(function (user) {
        if (window.top.webkit) {
          jQuery('#apiLogin').submit();
          var canLogin = false;
          setInterval(function () {
            if (canLogin === false && window.parent.webkit) {
              canLogin = true; //window.parent.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({"my_message" : "success"}));

              window.parent.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
                "my_message": "login",
                "email": username,
                "password": password
              }));
            }
          }, 1000);
        } else {
          userService().getCurrentUser().done(function (responseData) {
            var user = {
              id: responseData.data.id,
              firstName: responseData.data.firstName,
              lastName: responseData.data.lastName,
              address: responseData.data.address != undefined ? responseData.data.address.address : "",
              city: responseData.data.address != undefined ? responseData.data.address.city : "",
              phone: responseData.data.phone,
              email: responseData.data.email
            }; //console.log(responseData);

            localStorage.setItem('currentUserWeb', JSON.stringify(user));
          });
        }

        jQuery('#apiLogin').submit();
      });
    }).fail(function (res) {
      jQuery(".errors-box ul").html('<li>' + JSON.parse(res.responseText).error_description + '</li>');
      jQuery(".errors-box").addClass('flashDisplay');
      setTimeout(function () {
        jQuery(".errors-box").removeClass('flashDisplay');
      }, 900); //event.preventDefault();
    });
  });

  if (localStorage.getItem('currentUserWeb') != null) {
    var user = JSON.parse(localStorage.getItem('currentUserWeb'));
    jQuery('#billing_first_name').val(user.firstName);
    jQuery('#billing_last_name').val(user.lastName);
    jQuery('#billing_address_1').val(user.address);
    jQuery('#billing_phone').val(user.phone);
    jQuery('#billing_email').val(user.email);

    if ($('#billing_city').is('select')) {
      if ($('#billing_city option[value="' + user.city + '"]').length > 0) {
        setTimeout(function () {
          $('#billing_city option[value="' + user.city + '"]').trigger('click');
        }, 500);
      }
    } else {
      jQuery('#billing_city').val(user.city);
    }
  }

  var json_str = getCookie('user');

  if (json_str != "") {
    var json_encode = JSON.stringify(json_str);
    var json_parse = JSON.parse(json_encode);
    var json_parse_2 = JSON.parse(json_parse);
    if (json_parse_2.firstName) jQuery('#billing_first_name').val(json_parse_2.firstName.split('+').join(' '));
    if (json_parse_2.lastName) jQuery('#billing_last_name').val(json_parse_2.lastName.split('+').join(' '));
    if (json_parse_2.address) jQuery('#billing_address_1').val(json_parse_2.address.split('+').join(' '));
    if (json_parse_2.city) jQuery('#billing_city').val(json_parse_2.city.split('+').join(' '));
    if (json_parse_2.phone) jQuery('#billing_phone').val(json_parse_2.phone);
    if (json_parse_2.email) jQuery('#billing_email').val(json_parse_2.email);
  }
});

},{}]},{},[1]);
